import axios from 'axios'
import store from '../store'
import Vue from '../main'
import startRequest from '../startServer/request'
// @todo move baseURL to config file

const baseURL =
  process.env.NODE_ENV === 'production'
    ? 'https://redd-backend.calyxinternal.com/api'
    : 'http://localhost:3000/api'
    // : 'http://192.168.1.188:3000/api'

const request = axios.create({
  baseURL
})
// request.defaults.timeout = 10000

// request.interceptors.request.use((config) => {
//   const url = process.env.NODE_ENV === 'production'
//     ? 'http://20.52.157.4:3000/'
//     : 'http://localhost:3000/'

//   axios.get(url + 'serverStatus').then(res => {
//     console.log(res)
//   }).catch(err => {
//     console.log(err)
//     startRequest.get()
//   })
//   return config
// }, function (error) {
//   return Promise.reject(error)
// })

request.interceptors.request.use((config) => {
  let token = store.getters['auth/accessToken']

  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
}, function (error) {
  return Promise.reject(error)
})

// Interceptor para añadir el token a las peticiones
request.interceptors.request.use((config) => {
  let token = store.getters['auth/accessToken']

  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
}, function (error) {
  return Promise.reject(error)
})

// Interceptor en caso de error token https://thedutchlab.com/blog/using-axios-interceptors-for-refreshing-your-api-token
request.interceptors.response.use((response) => {
  return response
}, async function (error) {
  const originalRequest = error.config
  // if (error.message === 'Network Error') {
  //   startRequest.get('startServer')
  // }
  if (error.response && error.response.status === 403 && originalRequest.path !== '/login') {
    store.dispatch('auth/logout', true)
    store.dispatch('app/setLoading', false)
  }
  return Promise.reject(error)
})

/*request.interceptors.response.use((response) => {
  return response
}, async function (error) {
   const originalRequest = error.config
 // if (error.message === 'Network Error') {
   // startRequest.get('startServer')
   // Vue.$eventHub.$emit('onNetworkError')
  }
  return Promise.reject(error)
})*/

export default request
